export const environment = {
    production: false,
    apiUrl: 'https://api.dev.ucappfin.com/api',
    signalRUrl: 'https://api.dev.ucappfin.com',
    environmentName: 'development'
};
